import { _t } from '@/locale';
import { PriceType } from './ServiceCard.types';

const baseTranslationKey = 'components.elements.Card.ServiceCard';

const formatNumber = (num: number) => {
  if (Number.isInteger(num)) {
    return num.toString();
  } else {
    return num.toFixed(2);
  }
};

export const getFormattedPrice = ({
  value,
  type,
  isMobileView,
  hasDiscounts = false,
}: {
  value: number[];
  type: PriceType;
  isMobileView: boolean;
  hasDiscounts?: boolean;
}) => {
  switch (type) {
    case 'from':
      return `${isMobileView || hasDiscounts ? _t('Fr.') : ''} ${formatNumber(value[0])} ${_t('kr')}`;
    case 'standard':
      return `${formatNumber(value[0])} ${_t('kr')}`;
    case 'free':
      return _t('Free');
    case 'range':
      return `${formatNumber(value[0])} - ${formatNumber(value[1])} ${_t('kr')}`;
    case 'optional':
      return isMobileView ? _t('salonGiftCardDescription') : _t(`${baseTranslationKey}.price.optional`);
    default:
      return '';
  }
};

export const getFormattedDiscountedPrice = (
  hasDiscounts: boolean,
  price: { type: PriceType; value: number[] },
  discounts: number[],
  isMobileView: boolean,
) => {
  const validPriceTypeForDiscount = getValidPriceTypeForDiscount(price, discounts);

  if (hasDiscounts && validPriceTypeForDiscount && price?.type !== 'variable') {
    return getFormattedPrice({
      type: price.type,
      value: [
        price?.value[0] - discounts[0],
        ...(price.type === 'range' && discounts[1] ? [price?.value[1] - discounts[1]] : []),
      ],
      isMobileView: isMobileView,
      hasDiscounts: true,
    });
  }

  if (price?.type === 'variable') {
    return !isMobileView ? _t('campaignOffer') : _t(`${baseTranslationKey}.price.campaignNoPrice`);
  }
};

export const getValidPriceTypeForDiscount = (price?: { type: PriceType; value: number[] }, discounts?: number[]) => {
  return (
    price?.type === 'from' ||
    price?.type === 'standard' ||
    (price?.type === 'range' && price?.value?.length > 1 && discounts?.length > 1) ||
    price?.type === 'variable'
  );
};

export const getPriceLabel = (type: PriceType, hasDiscounts: boolean) => {
  switch (type) {
    case 'free':
    case 'range':
    case 'standard':
      return _t('price');
    case 'from':
      return _t(`${baseTranslationKey}.price.label.from`);
    case 'optional':
      return _t(`${baseTranslationKey}.price.label.optional`);
    case 'variable':
      return hasDiscounts ? _t(`${baseTranslationKey}.price.label.variable`) : '';
    default:
      return '';
  }
};
